/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import EventNoteIcon from '@mui/icons-material/EventNote';
import Info from '@mui/icons-material/Info';

import LocalOffer from '@mui/icons-material/LocalOffer';
import LocationOn from '@mui/icons-material/LocationOn';
import { TwitterPicker } from 'react-color';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import TagsAutocomplete from '../../../../Autocompletes/Tags';
import colors from '../../../../../utils/colors';
import { primary } from '../../../../../utils/brandColors';
import TagList from '../../../../TagList';
import { getBarnUsersForAssignmentString } from '../../../../../utils/scheduleHelper';
import ParticipantListComponent from '../../../ParticipantList';
import TaskNameAutocomplete from '../../../../Autocompletes/TaskName';

const HeaderSection = ({
  schedule,
  event,
  name,
  setName,
  description,
  setDescription,
  additionalTags,
  setAdditionalTags,
  setDetailedLocation,
  detailedLocation,
  metadata,
  setMetadata,
  disabledForBeingInPast,
  assignment,
  type,
  taskTypeId,
}) => {
  const [displayColorPicker, setDisplayColorPicker] = React.useState(false);
  const [addDescription, setAddDescription] = React.useState(false);
  const [addLocation, setAddLocation] = React.useState(false);
  const [changeTags, setChangeTags] = React.useState(false);

  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap)

  React.useEffect(() => {
    setChangeTags(false);
    if (description && description.length > 0) {
      setAddDescription(true);
    } else {
      setAddDescription(false);
    }
    if (detailedLocation && detailedLocation.length > 0) {
      setAddLocation(true);
    } else {
      setAddLocation(false);
    }
  }, [name]);

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
      >
        <ListItem dense>
          <ListItemIcon><EventNoteIcon /></ListItemIcon>
          <ListItemText>
            <TaskNameAutocomplete
              sx={{ minWidth: '100%' }}
              size="small"
              variant="outlined"
              id="Name"
              label="Display Name"
              value={name}
              taskTypeId={taskTypeId}
              onChange={(e) => {
                setName(e.target.value || '');
              }}
            />
          </ListItemText>
          {
            !disabledForBeingInPast && (
              <Box
                sx={{
                  display: 'flex',
                  cursor: 'pointer',
                  marginLeft: '1rem',
                }}
              >
                <Box onClick={() => setDisplayColorPicker(true)}>Color</Box>
                <Tooltip title="Change task color">
                  <div
                    className="circle"
                    style={{
                      margin: 'auto',
                      marginLeft: '0.5rem',
                      height: '26px',
                      width: '26px',
                      borderRadius: '26px',
                      cursor: 'pointer',
                      backgroundColor:
                        (metadata && metadata.calendarDisplayColor) || primary.main,
                    }}
                    role="presentation"
                    onClick={() => setDisplayColorPicker(true)}
                  />
                </Tooltip>
                {
                  displayColorPicker
                  && (
                    <div
                      style={{
                        position: 'absolute',
                        right: 50,
                        zIndex: 100,
                      }}
                    >
                      <div
                        style={{
                          position: 'fixed',
                          top: 0,
                          right: 0,
                          bottom: 0,
                          left: 0,
                        }}
                        onClick={() => setDisplayColorPicker(false)}
                        onKeyDown={() => setDisplayColorPicker(false)}
                        role="presentation"
                      />
                      <Paper>
                        <TwitterPicker
                          colors={colors}
                          color={(metadata && metadata.calendarDisplayColor) || primary.main}
                          disabled={disabledForBeingInPast}
                          onChange={(e) => {
                            const calendarDisplayColor = e.hex;
                            setMetadata({
                              ...metadata,
                              calendarDisplayColor,
                            });
                            if (e.hex.length === 6) {
                              setDisplayColorPicker(false);
                            }
                          }}
                          direction="vertical"
                        />
                        <Box
                          sx={{
                            mx: 2,
                            pb: 1,
                            fontSize: 14,
                            fontWeight: 300,
                            zIndex: 10000,
                            position: 'relative',
                          }}
                        >
                          <Typography fontWeight={300} component="div">Pick your own color on the</Typography>
                          <a href="https://g.co/kgs/rxPsQ5R" target="blank">Google Hex Color Picker</a>
                        </Box>
                      </Paper>
                    </div>

                  )
                }
              </Box>
            )
          }
        </ListItem>
        <ListItem dense>
          <ListItemIcon><LocalOffer /></ListItemIcon>
          <ListItemText>
            {
              changeTags
                ? (
                  <TagsAutocomplete
                    onSelect={(e, value) => { setAdditionalTags(value); }}
                    value={additionalTags}
                    size="small"
                  // disabled={disabledForBeingInPast}
                  />
                )
                : (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <TagList tags={additionalTags} disableGutters />
                    <Link
                      component="button"
                      variant="body2"
                      color="secondary"
                      underline="hover"
                      onClick={() => setChangeTags(true)}
                      sx={{ ml: 2 }}
                    >
                      Modify Tags
                    </Link>
                  </Box>
                )
            }
          </ListItemText>
        </ListItem>
        <Grid item xs={12}>
          <ListItem dense>
            <ListItemIcon><Info /></ListItemIcon>
            <ListItemText>
              {
                addDescription
                  ? (
                    <TextField
                      sx={{ minWidth: '100%' }}
                      size="small"
                      variant="outlined"
                      id="description"
                      label="Information"
                      value={description}
                      multiline
                      rows="2"
                      onChange={(e) => setDescription(e.target.value)}
                    // disabled={disabledForBeingInPast}
                    />
                  )
                  : (
                    <Link
                      component="button"
                      variant="body2"
                      color="secondary"
                      underline="hover"
                      onClick={() => setAddDescription(true)}
                    >
                      Add Task Information
                    </Link>
                  )
              }
            </ListItemText>
          </ListItem>
        </Grid>
        <ListItem dense>
          <ListItemIcon><LocationOn /></ListItemIcon>
          <ListItemText>
            {
              addLocation
                ? (
                  <TextField
                    sx={{
                      minWidth: '100%',
                      textWrap: 'auto',
                    }}
                    size="small"
                    variant="outlined"
                    id="detailed-location"
                    label="Location Details"
                    value={detailedLocation || ''}
                    onChange={(e) => setDetailedLocation(e.target.value)}
                    disabled={disabledForBeingInPast}
                    helperText={disabledForBeingInPast && 'Cannot be modified after the schedule start time of the task'}
                  />
                )
                : (
                  <Link
                    component="button"
                    variant="body2"
                    color="secondary"
                    underline="hover"
                    onClick={() => setAddLocation(true)}
                  >
                    {disabledForBeingInPast
                      ? 'No location details specified'
                      : 'Add Task Location'}
                  </Link>
                )
            }
          </ListItemText>
        </ListItem>

        {
          schedule && schedule.id && event && type === 'Invitation' && (
            <ParticipantListComponent
              participants={getBarnUsersForAssignmentString(assignment || '', barnUsersMap)}
              schedule={schedule}
              occurrenceDate={event && event.start}
              defaultOpen={false}
            />
          )
        }
      </Grid>
    </Grid>
  );
};

HeaderSection.propTypes = {
  schedule: PropTypes.object,
  event: PropTypes.object,
  name: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  setDescription: PropTypes.func.isRequired,
  additionalTags: PropTypes.array.isRequired,
  setAdditionalTags: PropTypes.func,
  setDetailedLocation: PropTypes.func,
  detailedLocation: PropTypes.string,
  metadata: PropTypes.any,
  setMetadata: PropTypes.func,
  disabledForBeingInPast: PropTypes.bool,
  assignment: PropTypes.string,
  type: PropTypes.string,
  taskTypeId: PropTypes.number,
};

HeaderSection.defaultProps = {
  schedule: null,
  event: null,
  detailedLocation: null,
  disabledForBeingInPast: false,
  assignment: '',
  type: 'Default',
  setAdditionalTags: () => { },
  setDetailedLocation: () => { },
  metadata: {},
  setMetadata: () => { },
  taskTypeId: null,
};

export default HeaderSection;
